import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import NewActionPanel from 'react-components/member-feed/components/newActionPanel/newActionPanel';
import { membersRequests } from 'redux/requests/members.request';
import { useAppSelector } from 'redux/store-hooks';
import { makeRequest } from 'redux/utils/api-request';
import AlertWrapper from 'toolkit/alerts/alert-wrapper';
import { MemberHeader } from '../member-header/MemberHeader';
import MemberProfile from '../member-profile/memberProfile';
import { EngageConfetti } from './engage-confetti';
import { selectSelectedMember } from 'redux/slices/memberSlice';
import { useFeatureFlag } from 'redux/utils/feature-flags/feature-flag-hook';
import GoalsFeed from 'react-components/goals/GoalsFeed';
import PostCallSummaryContext from './post-call-summary-drawer/PostCallSummaryContext';
import PostCallSummaryDrawer from './post-call-summary-drawer/PostCallSummaryDrawer';
import TranscriptionDrawer_OLD from './post-call-summary-drawer/TranscriptionDrawer_OLD';
import { ToastProvider } from 'react-components/app/ReusableToast';
import {
  AppHeaderPortal,
  FlexContainer,
  ToggleSwitch,
  useDisplayModeContext,
} from '@act/storybook';
import MemberPageView from './MemberPageView';
import { useMobile } from '@act/utilities/mobile-context';

export const FEED_VIEW = 'feed_view';
export const PROFILE_VIEW = 'profile_view';

export const MemberPage = () => {
  const callDataQualityFF = useFeatureFlag('call-data-quality');
  const { isMobile } = useMobile();
  const { displayMode } = useDisplayModeContext();
  const selectedMember = useAppSelector(selectSelectedMember);
  const [selectedSection, setSelectedSection] = useState<string>(FEED_VIEW);
  const [voiceCallId, setVoiceCallId] = useState<number | null>(null);

  useEffect(() => {
    if (selectedMember?.id) {
      makeRequest(membersRequests.postMemberViewedEvent, {
        params: { memberId: selectedMember?.id },
      }).catch(() => {});
    }
  }, [selectedMember?.id]);

  if (!selectedMember) {
    return <></>;
  }

  return (
    <>
      <ToastProvider>
        <PostCallSummaryContext.Provider
          value={{ voiceCallId, setVoiceCallId }}
        >
          <FlexContainer
            direction="column"
            height="100%"
            overflow="hidden"
            gap={2}
          >
            <AlertWrapper mode="member" />

            {isMobile && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <ToggleSwitch
                  options={[
                    { label: 'Activity feed', value: FEED_VIEW },
                    { label: 'Member profile', value: PROFILE_VIEW },
                  ]}
                  value={selectedSection}
                  onChange={setSelectedSection}
                />
              </Box>
            )}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '2fr 3fr',
                gap: '0 16px',
                flex: 1,
                minHeight: 0,
                overflow: 'hidden',

                '@media (max-width: 1068px)': {
                  gridTemplateColumns: '1fr',
                  padding: isMobile ? 0 : '12px 0px 0px',
                  gap: '0',
                },
              }}
            >
              <MemberPageView isSelected={selectedSection === FEED_VIEW}>
                <GoalsFeed member={selectedMember} />
              </MemberPageView>
              <MemberPageView isSelected={selectedSection === PROFILE_VIEW}>
                <MemberProfile />
              </MemberPageView>
            </Box>
          </FlexContainer>
          <EngageConfetti user={selectedMember} />
          <NewActionPanel />
          {callDataQualityFF ? (
            <PostCallSummaryDrawer
              open={voiceCallId !== null}
              displayMode={displayMode}
              onClose={() => setVoiceCallId(null)}
            />
          ) : (
            <TranscriptionDrawer_OLD
              selectedMember={selectedMember}
              open={voiceCallId !== null}
              onClose={() => setVoiceCallId(null)}
            />
          )}
          <AppHeaderPortal>
            <MemberHeader
              user={selectedMember}
              selectedSection={selectedSection}
              updateSelectedSection={setSelectedSection}
            />
          </AppHeaderPortal>
        </PostCallSummaryContext.Provider>
      </ToastProvider>
    </>
  );
};
